import React from "react";
import Header from "../header/Header";
import Terms from "../components/terms/Terms";

const TermsOfUse: React.FC = () => {
  return (
    <section>
      <Header />
      <Terms />
    </section>
  );
};

export default TermsOfUse;
